import { array, boolean, intersect, nullable, partial, string, struct } from 'io-ts/Decoder';

import { ParentId } from '../file/ParentId';

import { FolderType } from './FolderType';
import { Id } from './Id';
import { ParentType } from './ParentType';
import { Tag } from './Tag';

export const RefItem = intersect(
	struct({
		id: Id,
		parentId: ParentId,
		parentType: ParentType,
		parentFolderId: nullable(Id),
		name: string,
	})
)(
	partial({
		folderType: FolderType,
		tags: array(Tag),

		isDeleted: boolean,
		isUnknown: boolean,
	})
);
